// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gcdqvxjwhoujzbkzpdjn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdjZHF2eGp3aG91anpia3pwZGpuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk3NTQxNTYsImV4cCI6MjA3NTMzMDE1Nn0.NYIGNmtKneGm_ubQr-pylBzGINQMGraQZbbzkzIPalY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});